/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobOutcomeNextDownload = core.serialization.object({
    url: core.serialization.string(),
    label: core.serialization.string().optional(),
    fileName: core.serialization.string().optional(),
});
